import {
    Avatar,
    Badge,
    Box,
    Button,
    Card,
    CardHeader,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Divider,
    IconButton,
    List,
    ListItem,
    ListItemAvatar,
    ListItemSecondaryAction,
    ListItemText,
    Paper,
    Typography,
  } from '@material-ui/core';
  import { makeStyles, withStyles } from '@material-ui/core/styles';
  import DeleteSweepIcon from '@material-ui/icons/DeleteSweep';
  import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
  import { SwipeableListItem } from '@sandstreamdev/react-swipeable-list';
  import '@sandstreamdev/react-swipeable-list/dist/styles.css';
  import PropTypes from 'prop-types';
  import React, { useEffect } from 'react';
  import { confirmAlert } from 'react-confirm-alert';
  import 'react-confirm-alert/src/react-confirm-alert.css';
  import { useTranslation } from 'react-i18next';
  import { connect } from 'react-redux';
  import moment from 'moment';
  import axios from 'src/utils/axios';
  import {
    getHistoricalMaterialRequest,
    setCurrentDefect,
    setDefectFilterKey,
    setLabourFilterKey,
    setLabourSelection,
    setMaterialFilterKey,
    setMaterialSelection
  } from '../store/actions';
  import { setTask } from '../store/actions/taskActions';
  import ComplexSwipeContent from './ComplexSwipeContent';
  import SelectDefect from './SelectDefect';
  import SelectLabour from './SelectLabour';
  import SelectMaterial from './SelectMaterial';
  
  import { getUser, moneyFormat } from 'src/utils/Common';
  
  const useStyles = makeStyles(theme => ({
    root: {},
    ListDiv: {
      backgroundColor: theme.palette.common.siyah
    },
    expand: {
      transform: 'rotate(0deg)',
      marginLeft: 'auto',
      transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest
      })
    },
    error: {
      backgroundColor: theme.palette.error.main,
      color: theme.palette.error.contrastText
    },
    expandOpen: {
      transform: 'rotate(180deg)'
    },
    value: {
      fontWeight: theme.typography.fontWeightMedium
    },
    type: {
      fontWeight: theme.typography.fontWeightMedium
    },
    search: {
      flexGrow: 1,
      height: 42,
      padding: theme.spacing(0, 2),
      display: 'flex',
      alignItems: 'center'
    },
    searchIcon: {
      marginRight: theme.spacing(2),
      color: theme.palette.icon
    },
    searchInput: {
      flexGrow: 1
    },
    pageStyle: {
      display: 'flex',
      padding: '2px 4px'
    },
    input: {
      marginLeft: theme.spacing(1),
      flex: 1
    },
    iconButton: {
      padding: 10
    },
    divider: {
      height: 28,
      margin: 4
    },
    searchButton: {
      backgroundColor: theme.palette.common.white,
      marginLeft: theme.spacing(2)
    },
    fields: {
      margin: theme.spacing(-1),
      display: 'flex',
      flexWrap: 'wrap',
      '& > *': {
        flexGrow: 1,
        margin: theme.spacing(1)
      }
    },
    backdrop: {
      zIndex: theme.zIndex.drawer + 1,
      color: '#fff'
    },
    content: {
      marginLeft: theme.spacing(0)
    },
    nested: {
      backgroundColor: theme.palette.common.white,
      marginLeft: theme.spacing(1),
      marginBottom: theme.spacing(1)
    },
    nestedRight: {
      backgroundColor: theme.palette.common.white,
      marginLeft: theme.spacing(1),
      marginBottom: theme.spacing(1),
      marginRight: theme.spacing(7)
    },
    smallIcon: {
      height: 15,
      width: 15
    },
    toplam: {
      margin: theme.spacing(-1),
      display: 'flex',
      flexWrap: 'wrap',
      align: 'right',
      '& > *': {
        flexGrow: 1,
        margin: theme.spacing(1)
      }
    },
    action: {
      paddingTop: 12
    },
    submitButtonWudaq: {
      marginTop: theme.spacing(0),
      width: '100%'
    },
    button: {
      marginTop: theme.spacing(1),
      width: '50%'
    },
    cardsMax: {
      maxHeight: 300,
      minHeight: 300
    }
  }));
  
  const defaultProps = {
    bgcolor: 'background.paper',
    borderColor: '#1D3343',
    border: 1,
    marginLeft: 0.5,
    marginRight: 0.5,
    marginBottom: 0.5
  };
  
  const defaultPropsChild = {
    bgcolor: 'background.paper',
    borderColor: '#cfcfcf',
    border: 1,
    marginLeft: 0.5,
    marginRight: 0.5,
    marginBottom: 0.5
  };
  
  const SmallAvatar = withStyles(theme => ({
    root: {
      width: 20,
      height: 20
    }
  }))(Avatar);
  
  function HizmetPage(props) {
    const classes = useStyles();
    const { t } = useTranslation('work_order');
    const [openDefect, setOpenDefect] = React.useState(false);
    const [openMaterial, setOpenMaterial] = React.useState(false);
    const [openLabour, setOpenLabour] = React.useState(false);
    const [materialSum, setMaterialSum] = React.useState(0);
    const [materialVatSum, setMaterialVatSum] = React.useState(0);
    const [stokOpen, setStokOpen] = React.useState(false);
    const [loading, setLoading] = React.useState(false);
    const [stokData, setStokData] = React.useState([]);
    const [GosterimAdet, setGosterimAdet] = React.useState(30);
    const [open, setOpen] = React.useState(false);
    const [Uyari, setUyari] = React.useState('');
    const SessionUser = getUser();
  
    const handleClose = () => {
      setOpen(false);
    };
    useEffect(() => {
      let currMaterialSum = 0;
      let currMaterialVatSum = 0;
      if (props.defects && props.defects.selected) {
        props.defects.selected.forEach((row, index) => {
          if (props.materials && props.materials.materialsTable) {
            if (props.materials[row]) {
              props.materials[row].forEach((mrow, index) => {
                currMaterialSum +=
                  props.materials[mrow] *
                  props.materials.materialsTable[mrow]?.PriceWithWat;
                currMaterialVatSum +=
                  props.materials[mrow] *
                  props.materials.materialsTable[mrow]?.Price;
              });
            }
          }
        });
      }
      setMaterialSum(currMaterialSum);
      setMaterialVatSum(currMaterialVatSum);

    }, [props.defects, props.materials, props.tasks.tasks]);
    
    const MalzemeSil = (Malzeme, index, Hizmet) => {
      let Uyari =
        Malzeme.MaterialCode + ' ' + Malzeme.MaterialDesc + ' ' + t('Sil');
      confirmAlert({
        message: Uyari,
        buttons: [
          {
            label: t('Evet'),
            onClick: () => MalzemeSilEvet(Malzeme, index, Hizmet)
          },
          {
            label: t('Hayir'),
            onClick: () => { }
          }
        ]
      });
    };
    
    const MalzemeSilEvet = (Malzeme, index, Hizmet) => {
      const selected = props.materials[Hizmet] || [];
      const selectedIndex = selected.indexOf(Malzeme.MaterialCode);
      let newSelected = [];
      if (selectedIndex === -1) {
        return;
      }
      newSelected = [
        ...selected.slice(0, selectedIndex),
        ...selected.slice(selectedIndex + 1)
      ];
  
      props.setMaterialSelection(Hizmet, newSelected);
    };
  
    const getStokColor = s => {
      if (s.Quantity > 0) {
        return (
          <Avatar
            size="small"
            style={{ color: 'white', backgroundColor: 'green' }}
          >
            <ShoppingCartIcon />
          </Avatar>
        );
      } else {
        return (
          <Avatar
            size="small"
            onClick={() => {
              setUyari(s.Date || '');
              setOpen(true);
            }}
            style={{ color: '#424242', backgroundColor: 'red' }}
          >
            <ShoppingCartIcon />
          </Avatar>
        );
      }
    };

    return (
      <div>
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-slide-title"
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogTitle id="alert-dialog-slide-title" color="primary">
            {t('Bilgilendirme')}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
              {Uyari}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="primary">
              {t('Tamam')}
            </Button>
          </DialogActions>
        </Dialog>
        <Card className={classes.cardsMax}>
          <CardHeader
            avatar={
              <IconButton
                edge="end"
                size="small"
                disabled={props.readonly}
                onClick={() => setOpenDefect(true)}
              >
                <Badge
                  overlap="circle"
                  size="small"
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right'
                  }}
                  badgeContent={
                    <SmallAvatar
                      style={{ backgroundColor: '#1D3343', color: '#FFFFFF' }}
                    >
                      +
                    </SmallAvatar>
                  }
                >
                  <Avatar
                    style={{ backgroundColor: '#1D3343', color: '#FFFFFF' }}
                  >
                    D
                  </Avatar>
                </Badge>
              </IconButton>
            }
            title={<Typography variant="h6">{t('HizmetEkle')} </Typography>}
          />
          <Paper style={{ maxHeight: '250px', overflow: 'auto' }}>
            <List component="div" dense>
              {props.defects.selected &&
                props.defects.selected.map((row, index) => {
                  if (!props.defects.defectsTable) return null;
                  const dd = props.defects.defectsTable[row];
                  const montaj = dd?.DefectTypeCode === 3;
                  return (
                    dd && (
                      <Box key={row} borderRadius={16} {...defaultProps}>
                        <ListItem key={row}>
                          <ListItemText
                            primary={
                              <Typography variant="h6">
                                {dd.CategoryLevel2 + ', ' + dd.DefectType + ' - ' + dd.DefectDesc }
                              </Typography>
                            }
                          />
                          {!props.readonly && (
                            <div>
                              <IconButton
                                edge="end"
                                size="small"
                                disabled={props.readonly}
                                onClick={() => {
                                  props.setCurrentDefect(row);
                                  setOpenMaterial(true);
                                }}
                              >
                                <Badge
                                  overlap="circle"
                                  size="small"
                                  anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'right'
                                  }}
                                  badgeContent={
                                    <SmallAvatar
                                      style={{
                                        backgroundColor: '#1D3343',
                                        color: '#FFFFFF'
                                      }}
                                    >
                                      +
                                    </SmallAvatar>
                                  }
                                >
                                  <Avatar
                                    style={{
                                      backgroundColor: '#1D3343',
                                      color: '#FFFFFF'
                                    }}
                                  >
                                    M
                                  </Avatar>
                                </Badge>
                              </IconButton>
                            </div>
                          )}
                        </ListItem>
                        <Box borderRadius={16} {...defaultPropsChild}>
                          {props.materials[row] &&
                            props.materials[row].map((mrow, index) => (
                              <ListItem dense={true} key={mrow}>
                                <SwipeableListItem
                                  dense={true}
                                  swipeLeft={{
                                    content: (
                                      <ComplexSwipeContent
                                        icon={<DeleteSweepIcon />}
                                        label={t('SilButon')}
                                        position="right"
                                        css="hizmet"
                                      />
                                    ),
                                    action: () =>
                                      MalzemeSil(
                                        props.materials.materialsTable[mrow],
                                        index,
                                        row
                                      )
                                  }}
                                  blockSwipe={props.readonly}
                                >
                                  <ListItemText>
                                    <Typography
                                      key={mrow}
                                      variant="body1"
                                      className={classes.nestedRight}
                                    >
                                      <b>{mrow}</b>
                                      {' ' +
                                        props.materials.materialsTable[mrow]?.MaterialDesc +
                                        ' Ref:' +
                                        props.materials.materialsTable[mrow]?.Ref}
                                    </Typography>
                                    <Divider />
                                  </ListItemText>
                                  <ListItemSecondaryAction
                                    className={classes.nested}
                                  >
                                    <Typography variant="h6">
                                      {moneyFormat(
                                        props.materials.materialsTable[mrow]?.Price,
                                        SessionUser.TenantCode,
                                        SessionUser.CurrencyUnit
                                      )}
                                      {' ' + SessionUser.CurrencyUnit + ' |  '}
                                      {(props.materials[mrow] || '1') +
                                        ' ' +
                                        t('lblAdet') + ' |  '}
                                      <Button 
                                        variant="contained"
                                        size="small"
                                        color="primary"
                                        onClick={()=>props.handleAddMatchedPairs(props.defects.defectsTable[row],props.materials.materialsTable[mrow])}
                                      >
                                        {t('lblUse')}
                                      </Button>
                                    </Typography>
                                  </ListItemSecondaryAction>
                                </SwipeableListItem>
                              </ListItem>
                            ))}
                        </Box>
                      </Box>
                    )
                  );
                })}
            </List>
          </Paper>
          <Divider />
          <br />
          <SelectDefect
            open={openDefect}
            onClose={() => setOpenDefect(false)}
            ReceiptNo={props.ReceiptNo}
            title={t('hizmet_secimi')}
          />
          <SelectMaterial
            open={openMaterial}
            onClose={() => {
              setOpenMaterial(false);
              setMaterialFilterKey('');
              setGosterimAdet(30);
            }}
            title={t('malzeme_secimi')}
            ReceiptNo={props.ReceiptNo}
            GosterimAdet={GosterimAdet}
            setGosterimAdet={setGosterimAdet}
            ProductCode={props.kulModelKodu}
            defect={props.defects.currentDefect}
          />
          <SelectLabour
            open={openLabour}
            onClose={() => {
              setOpenLabour(false);
              setLabourFilterKey('');
            }}
            garantiTipi={props.garantiTipi}
            title={t('iscilik_secimi')}
            ReceiptNo={props.ReceiptNo}
            defect={props.defects.currentDefect}
          />         
          <Dialog
            open={stokOpen}
            onClose={() => setStokOpen(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            fullWidth
          >
            <DialogTitle id="alert-dialog-title">
              {t('Malzeme_Stok_Durumu')}
              <Divider />
            </DialogTitle>
            <DialogContent>
              <List component="div" dense>
                {loading ? (
                  <CircularProgress
                    status="loading"
                    style={{ marginLeft: '50%' }}
                  />
                ) : (
                  stokData.map((s,index) => {
                    return (
                      <React.Fragment>
                        <ListItem
                          fullWidth
                          alignItems="flex-start"
                          key={index}
                        >
                          <ListItemAvatar>{getStokColor(s)}</ListItemAvatar>
                          <ListItemText
                            primary={
                              <Typography
                                key={index}
                                variant="body1"
                                className={classes.nestedRight}
                              >
                                <b>{s.MaterialCode}</b>
                              </Typography>
                            }
                            secondary={
                              <React.Fragment>
                                <Typography
                                  component="span"
                                  variant="h6"
                                  className={classes.inline}
                                  color="textPrimary"
                                >
                                   {t('StorageDesc')} : {s.StorageLocation}
                                    <br />
                                    {t('lblAdet')} : {s.Quantity} 
                                    <br />
                                    {t('Tarih')} : {s.Date != null ? moment(s.Date).format('DD/MM/YYYY') : "-"}
                                    <br />
                                    {SessionUser.TenantId === 87 || SessionUser.TenantId === 16 && ( 
                                      <div>
                                        {t('ETA')} : {s.ETA === new Date(0).getTime() || s.Quantity == 0 ? "-": moment(s.ETA).format('DD/MM/YYYY')}
                                      </div>
                                    )}
                                </Typography>
                              </React.Fragment>
                            }
                          />
                        </ListItem>
                        <Divider variant="inset" component="li" />
                      </React.Fragment>
                    );
                  })
                )}
              </List>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setStokOpen(false)} color="primary">
                {t('Tamam')}
              </Button>
            </DialogActions>
          </Dialog>
        </Card>
      </div>
    );
  }
  
  const mapStateToProps = state => ({
    defects: state.defectReducer,
    materials: state.materialReducer,
    labours: state.labourReducer,
    tasks: state.tasks1
  });
  
  const mapDispatchToProps = {
    setCurrentDefect,
    setDefectFilterKey,
    setLabourFilterKey,
    setMaterialFilterKey,
    setMaterialSelection,
    setLabourSelection,
    getHistoricalMaterialRequest,
    setTask
  };
  mapStateToProps.propTypes = {
    className: PropTypes.string
  };
  
  export default connect(mapStateToProps, mapDispatchToProps)(HizmetPage);